module.exports = new __parcel__URL__("JiraProjectDiscovery.59099094.svg").toString();